import { Link } from 'react-router-dom';

interface Movie {
  id: number;
  title: string;
  category: string;
  rating: number;
  year: number;
  image: string;
}

interface MovieCardProps {
  movie: Movie;
  categoryName?: string;
}

const categorySlugs: Record<string, string> = {
  dongzuo: '动作片',
  xiju: '喜剧片',
  aiqing: '爱情片',
  kongbu: '恐怖片',
  kehuan: '科幻片',
  dongman: '动漫',
  juqing: '剧情片',
  jilu: '纪录片',
};

export default function MovieCard({ movie, categoryName }: MovieCardProps) {
  return (
    <Link
      to={`/category/${movie.category}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden">
        <img
          src={movie.image}
          alt={movie.title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
        <div className="absolute top-2 right-2 bg-primary-500 text-white text-xs font-bold px-2 py-1 rounded-md">
          {movie.rating}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-white text-sm font-semibold truncate">{movie.title}</h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-white/70 text-xs">{movie.year}</span>
            <span className="text-white/50 text-xs">·</span>
            <span className="text-white/70 text-xs">
              {categoryName || categorySlugs[movie.category] || movie.category}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}